import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import theme from 'fe-appdir-lib-theme';

const PROP_TYPES = {
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  isTransparent: PropTypes.bool,
  zIndex: PropTypes.number,
};

const DEFAULT_PROPS = {
  isTransparent: false,
  zIndex: -1,
};

const Background = styled.div`
  visibility: hidden;
  opacity: 0;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${(props) => props.zIndex};
  transition: opacity 0.25s ease-out, visibility 0s ease-out 0.15s;
  background-color: ${(props) =>
    props.isTransparent ? 'transparent' : `${theme.colorBlack}`};
  ${(props) =>
    props.isOpen
      ? 'visibility: visible; opacity: 0.5; transition-delay: 0s;'
      : ''}
`;

const Backdrop = ({ isOpen, onClick, isTransparent, zIndex }) => (
  <Background
    isOpen={isOpen}
    onClick={onClick}
    isTransparent={isTransparent}
    zIndex={zIndex}
  />
);

Backdrop.propTypes = PROP_TYPES;
Backdrop.defaultProps = DEFAULT_PROPS;
Backdrop.displayName = 'Backdrop';

export default Backdrop;
